<div class="app-linha-topo"></div>


<div class="container app-container col-xs-12">
  <div class="col-xs-12 text-center" style="margin-top: 40px;">
    <div class="app-logotipo" style="margin: 0 auto !important;">
      <img src="{{ logo }}" alt="Logotipo">
    </div>
  </div>

  <div *ngIf="processando" class="text-center" style="margin-top: 1em;">
    <i class="fa fa-spinner fa-pulse fa-4x"></i>
    <p>Carregando...</p>
  </div>
  
  <form (submit)="cadastrar()"
        ngNativeValidate
        *ngIf="possuiAcessoAoCadastro && !processando">
    <article class="col-xs-12 col-md-10 col-md-offset-1">
        <h4>
           Informe seus dados para efetuar um pré cadastro em nossa plataforma e garantir seu acesso a
           ferramenta
        </h4>
    </article>
    <div class="container col-xs-12 col-md-8 col-md-offset-2 col-lg-6 col-lg-offset-3">
      <div>
        <!--Dados pessoais -->
        <div class="panel panel-default">
          <div class="panel-heading"> Dados Pessoais
          </div>
          <div class="panel-body">
  
            <div class="form-group col-xs-12">
              <div class="">
                <label for="nascimento">E-mail</label>
                <input type="email"
                       [(ngModel)]="dadosCadastrais.email"
                       name="dadosCadastrais.email"
                       class="form-control input-sm" id="email"
                       placeholder="meu@email.com"
                  required>
              </div>
            </div>
            <div class="form-group col-xs-12">
              <label for="documento">Documento</label>
              <div class="input-group">
                <div class="input-group-btn">
                  <button type="button" class="btn btn-sm" [ngClass]="{'app-btn-best': documentoTipo === 'CPF'}" (click)="documentoTipo = 'CPF'">
                       <i [ngClass]="{'fa fa-check': documentoTipo === 'CPF'}"></i> CPF
                </button>
  
                  <button type="button" class="btn btn-sm " [ngClass]="{'app-btn-best': documentoTipo === 'CNPJ'}" (click)="documentoTipo = 'CNPJ'">
                        <i [ngClass]="{'fa fa-check': documentoTipo === 'CNPJ'}"></i> CNPJ
                </button>
                </div>
                <input type="text" id="documento" class="form-control input-sm" [(ngModel)]="dadosCadastrais.documento" name="dadosCadastrais.documento"
                  *ngIf="documentoTipo === 'CPF'" UiCpf required>
  
                <input type="text"
                       id="documento"
                       class="form-control input-sm"
                       [(ngModel)]="dadosCadastrais.documento"
                       name="dadosCadastrais.documento"
                       (ngModelChange)="dadosCadastrais.documentoValido = true"
                       *ngIf="documentoTipo === 'CNPJ'" 
                       UiCnpj required>
              </div>
  
              <p class="help-block">Formato: {{ documentoTipo === 'CPF' ? '00000000000' : '00000000000000' }}</p>
                
            </div>
  
          </div>
        </div>
  
        <div class="col-xs-12 text-center" style="margin-top: 20px;margin-bottom: 60px;">
          <button (click)="router.navigate([''])" class="btn btn-danger-v2">
          Cancelar
          </button>
          <button type="submit"
                  *ngIf="dadosCadastrais.email !== undefined && dadosCadastrais.email !== '' && dadosCadastrais.documento !== undefined && dadosCadastrais.documento !== ''" class="btn btn-success-v2">
               Cadastrar
        </button>
  
        </div>
      </div>
    </div>
  </form>

</div>
<div class="rodape-externo" style="margin-bottom: 0">
  <img src="assets/img/fundo_img.png" alt="" class="img-responsive">
</div>


// WEBPACK FOOTER //
// ./src/app/cadastro-usuario/cadastro-usuario.component.html